var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weezie-logo-management",style:(_vm.route_name==='workspaces'? {    width: '160px'}:{}),on:{"click":function($event){return _vm.$router.push({ name: 'hub' })}}},[_c('img',{attrs:{"src":_vm.image_path,"alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b0a1c3d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/logos/WeezieLogo.vue
// module id = null
// module chunks = 